import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  ON_BOARDING_ADD_GLOBAL_THEMES_BEGIN,
  ON_BOARDING_ADD_GLOBAL_THEMES_SUCCESS,
  ON_BOARDING_ADD_GLOBAL_THEMES_FAILURE,
  ON_BOARDING_ADD_GLOBAL_THEMES_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addGlobalThemes(args = {}) {
  return (dispatch) => {
    dispatch({
      type: ON_BOARDING_ADD_GLOBAL_THEMES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/on-boarding/${projectId}/global-theme`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(url, args, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: ON_BOARDING_ADD_GLOBAL_THEMES_SUCCESS,
            data: res.data.data,
          });
          resolve(res);
          if (res && res.data && res.data.data && Array.isArray(res.data.data.customCssCdns)) {
            if (res.data.data.customCssCdns.some((theme) => theme.customType === 'GLOBAL_THEME')) {
              toast.success('Theme Added successfully');
            } else {
              toast.success('Theme Removed successfully');
            }
          } else {
            console.log('Invalid response structure or customCssCdns is not an array');
          }
        },
        (err) => {
          dispatch({
            type: ON_BOARDING_ADD_GLOBAL_THEMES_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Creation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddGlobalThemesError() {
  return {
    type: ON_BOARDING_ADD_GLOBAL_THEMES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ON_BOARDING_ADD_GLOBAL_THEMES_BEGIN:
      return {
        ...state,
        addGlobalThemesPending: true,
        addGlobalThemesError: null,
      };

    case ON_BOARDING_ADD_GLOBAL_THEMES_SUCCESS:
      return {
        ...state,
        addGlobalThemesPending: false,
        addGlobalThemesError: null,
        globalTheme: action.data.customCssCdns,
        projectDetail: action.data,
      };

    case ON_BOARDING_ADD_GLOBAL_THEMES_FAILURE:
      return {
        ...state,
        addGlobalThemesPending: false,
        addGlobalThemesError: action.data.error,
      };

    case ON_BOARDING_ADD_GLOBAL_THEMES_DISMISS_ERROR:
      return {
        ...state,
        addGlobalThemesError: null,
      };

    default:
      return state;
  }
}
